import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=09a5f7bf&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=09a5f7bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a5f7bf",
  null
  
)

export default component.exports